import React from 'react';
import { Link } from 'react-router-dom';

const RakanBoxPage: React.FC = () => {
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-6">الصندوق الراكاني</h1>
          <p className="text-xl max-w-3xl mx-auto">
            المكان الذي يحتضن إرثي الفكري والمعرفي، محتوى عام يتضمن ثقافتي في كل ما أبرع فيه
          </p>
        </div>
      </div>

      {/* Main Content - Simplified */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              في الصندوق الراكاني، أجمع بين كل ما حملته الأيام من علوم، نصوص، أفكار، ومناقشات في مجالات شتى تخدم الإنسان في دينه ودنياه.
              لا يهم الترتيب الصارم بقدر ما يهم الحفظ والاحتفاظ بكل ما له قيمة، كأنني أودع كنزي الخاص ليبقى محفوظًا ومتاحًا لمن بعدي.
            </p>
          </div>

          {/* Simplified Content Overview */}
          <div className="bg-white p-8 rounded-lg shadow-lg mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">محتوى الصندوق الراكاني</h2>
            <p className="text-gray-600 mb-8 text-center">
              يضم الصندوق الراكاني مجموعة متنوعة من المحتوى في مجالات مختلفة، بما في ذلك ريادة الأعمال، الفكر والثقافة، التنمية الشخصية، الدين والحياة، الفن والإبداع، والتقنية والابتكار.
            </p>
            
            <div className="flex justify-center">
              <div className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
                قريباً
              </div>
            </div>
          </div>

          {/* Coming Soon */}
          <div className="bg-gray-50 p-8 rounded-lg text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">قريباً المزيد من المحتوى</h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              أعمل حالياً على إضافة المزيد من المحتوى إلى الصندوق الراكاني. ترقبوا المزيد قريباً.
            </p>
            <Link to="/contact" className="inline-block bg-primary text-white hover:bg-primary-dark px-6 py-3 rounded-md font-medium transition duration-300">
              تواصل معي
            </Link>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="bg-gradient-to-r from-primary to-primary-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-6">هل ترغب في التواصل معي؟</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto">
            إذا كان لديك أي استفسار أو اقتراح، أو ترغب في مناقشة أي من المواضيع المطروحة، فلا تتردد في التواصل معي.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/contact" className="bg-white text-primary hover:bg-gray-100 px-6 py-3 rounded-md font-medium transition duration-300">
              تواصل معي
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RakanBoxPage;
